import jwtDecode from 'jwt-decode'
import Cookie from 'js-cookie'

// function getQueryParams () {
// 	const params = {}
// 	window.location.href.replace(/([^(?|#)=&]+)(=([^&]*))?/g, ($0, $1, $2, $3) => {
// 		params[$1] = $3
// 	})
// 	return params
// }

function getQueryParams(qs) {
	qs = qs.replace(/\+/g, ' ')
	var params = {}
	var re = /[?&]?([^=]+)=([^&]*)/g
	var tokens

	while (tokens === re.exec(qs)) {
		params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2])
	}

	return params
}

export function extractInfoFromHash() {
	if (process.SERVER_BUILD) return
	const obj = getQueryParams()
	return {
		token: obj.id_token,
		secret: obj.state
	}
}

export function setToken(token) {
	if (process.SERVER_BUILD) return
	window.localStorage.setItem('token', token)
	// window.localStorage.setItem('user', JSON.stringify(jwtDecode(token)))
	Cookie.set('jwt', token)
}

export function unsetToken() {
	if (process.SERVER_BUILD) return
	window.localStorage.removeItem('token')
	window.localStorage.removeItem('user')
	window.localStorage.removeItem('secret')
	window.localStorage.removeItem('vue-authenticate.vueauth_token')
	Cookie.remove('jwt')
	Cookie.remove('sessionid')
	Cookie.remove('messages')
	Cookie.remove('csrftoken')
	document.cookie.split(";").forEach(function(c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });
	window.localStorage.setItem('logout', Date.now())
}

export function getUserFromCookie(req) {
	if (!req.headers.cookie) return
	const jwtCookie = req.headers.cookie.split(';').find(function(c) {
		return c.trim().startsWith('jwt=')
	})
	if (!jwtCookie) return
	const jwt = jwtCookie.split('=')[1]
	return jwtDecode(jwt)
}

export function getToken() {
	const token = window.localStorage.token
	return token
}

export function getUserFromLocalStorage() {
	const json = window.localStorage.user
	return json ? JSON.parse(json) : undefined
}

export const setSecret = function(secret) {
	return window.localStorage.setItem('secret', secret)
}

export const checkSecret = function(secret) {
	return window.localStorage.secret === secret
}
